import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutGrid, Video, Radio, LogOut, ExternalLink } from "lucide-react";
import { clearAdminToken } from "../../lib/adminAuth";

const NAV = [
  { to: "/admin/programs", label: "Programlar", icon: LayoutGrid },
  { to: "/admin/videos", label: "Program Videoları", icon: Video },
  { to: "/admin/live", label: "Canlı Yayınlar", icon: Radio },
];

export default function AdminLayout() {
  const navigate = useNavigate();

  const logout = () => {
    clearAdminToken();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[var(--tv-bg)] text-[var(--tv-text)]">
      <header className="border-b border-[var(--tv-border)] bg-[#08080f]">
        <div className="max-w-6xl mx-auto px-5 py-4 flex items-center justify-between gap-4">
          <div>
            <p className="font-display font-bold text-white text-lg">TV13 Admin</p>
            <p className="text-xs text-[var(--tv-muted)]">İçerik yönetim paneli</p>
          </div>
          <div className="flex items-center gap-2">
            <a
              href="/"
              target="_blank"
              rel="noreferrer"
              className="tv-btn-ghost !py-2 !px-3 text-sm inline-flex items-center gap-2"
            >
              <ExternalLink size={16} /> Siteyi Gör
            </a>
            <button type="button" onClick={logout} className="tv-btn-ghost !py-2 !px-3 text-sm inline-flex items-center gap-2">
              <LogOut size={16} /> Çıkış
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-5 py-6">
        <nav className="flex flex-wrap gap-2 mb-6">
          {NAV.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `inline-flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold transition-colors ${
                  isActive
                    ? "bg-[rgba(139,92,246,0.2)] text-white border border-[rgba(168,85,247,0.45)]"
                    : "text-[var(--tv-muted)] border border-[var(--tv-border)] hover:text-white hover:border-[rgba(168,85,247,0.35)]"
                }`
              }
            >
              <Icon size={16} />
              {label}
            </NavLink>
          ))}
        </nav>
        <Outlet />
      </div>
    </div>
  );
}
